// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — add-form.styled.classic.js, новая — add-form.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './add-form.styled.classic';
import * as cp from './add-form.styled.cp';

export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const ButtonsRight = isCp ? cp.ButtonsRight : classic.ButtonsRight;
export const Center = isCp ? cp.Center : classic.Center;
export const CloseButton = isCp ? cp.CloseButton : classic.CloseButton;
export const Content = isCp ? cp.Content : classic.Content;
export const ContentPreview = isCp ? cp.ContentPreview : classic.ContentPreview;
export const ControlsButtons = isCp ? cp.ControlsButtons : classic.ControlsButtons;
export const Header = isCp ? cp.Header : classic.Header;
export const Inner = isCp ? cp.Inner : classic.Inner;
export const Left = isCp ? cp.Left : classic.Left;
export const NamePlace = isCp ? cp.NamePlace : classic.NamePlace;
export const Right = isCp ? cp.Right : classic.Right;
export const Title = isCp ? cp.Title : classic.Title;
